import { useCallback } from 'react';
import { useUpdateHabitPriorityTaskOrderMutation } from 'shared/hooks/queries/use-update-habit-priority-task-order-mutation';
import { useUpdateTaskMutation } from 'shared/hooks/queries/use-update-task-mutation';
import { SectionItemMove } from 'shared/hooks/use-droppable-section-controls';
import { Habit } from 'shared/types/habit';
import { SectionBase } from 'shared/types/orderable-section';
import { TaskPriorityOptions } from 'shared/types/task-base';

export const usePriorityHabitReorder = () => {
  const { mutate: updatePrioritySorting } =
    useUpdateHabitPriorityTaskOrderMutation();
  const { mutate: updateTask } = useUpdateTaskMutation();

  return useCallback(
    (
      newSections: SectionBase<Habit>[],
      movedItem: Habit,
      { sourceSectionId, targetSectionId }: SectionItemMove,
    ) => {
      const targetSection = newSections.find(
        ({ id }) => id === targetSectionId,
      );
      if (!targetSection) {
        return;
      }

      const prioritiesToUpdate = [
        {
          priority: targetSection.id as TaskPriorityOptions,
          taskIds: targetSection.items.map(({ id }) => id),
        },
      ];

      if (sourceSectionId !== targetSectionId) {
        const sourceSection = newSections.find(
          ({ id }) => id === sourceSectionId,
        );
        if (sourceSection) {
          prioritiesToUpdate.push({
            priority: sourceSection.id as TaskPriorityOptions,
            taskIds: sourceSection.items.map(({ id }) => id),
          });
        }

        updateTask({
          id: movedItem.id,
          priority: targetSection.id as TaskPriorityOptions,
        });
      }

      updatePrioritySorting(prioritiesToUpdate);
    },
    [updatePrioritySorting, updateTask],
  );
};
